const HomeLogo = (props) => (
  <svg
    width="50"
    height="50"
    viewBox="0 0 51 50"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3635_29747)">
      <path
        d="M39.495 18.538L26.7373 8.46451C25.8461 7.6665 24.6024 7.6665 23.7111 8.46451L17.6588 12.9312V7.6665H12.0313V17.0664L10.8809 18.538C10.3213 19.0665 10 19.8749 10 20.7351V41.535C10 43.0792 11.0364 44.3332 12.3111 44.3332H38.0648C39.3395 44.3332 40.3759 43.0792 40.3759 41.535V20.7351C40.3759 19.8749 40.0546 19.0665 39.495 18.538Z"
        fill="url(#paint0_radial_3635_29747)"
      />
      <path
        d="M17.6582 23.9792V42.9759C17.6582 43.7257 18.266 44.3335 19.0158 44.3335H31.359C32.1088 44.3335 32.7166 43.7257 32.7166 42.9759V23.9792C32.7166 23.2294 32.1088 22.6216 31.359 22.6216H19.0158C18.266 22.6216 17.6582 23.2294 17.6582 23.9792Z"
        fill="#3300FF"
      />
      <path d="M29.7536 22.5283H27.2041V44.3335H29.7536V22.5283Z" fill="white" />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_3635_29747"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(45.3401 11.4907) scale(40.1385)"
      >
        <stop stopColor="#3B6AF4" />
        <stop offset="1" stopColor="#19AEDF" />
      </radialGradient>
      <clipPath id="clip0_3635_29747">
        <rect width="30.3759" height="36.6667" fill="white" transform="translate(10 7.6665)" />
      </clipPath>
    </defs>
  </svg>
)

export default HomeLogo
